/**
 * API helpers for admin invite flow
 */

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" && window.location.port === "3002"
    ? "http://localhost:5001"
    : "");

export async function sendAdminInvite({ email, organizationId, organizationName }) {
  const res = await fetch(`${API_BASE}/api/send-admin-invite`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: email.trim().toLowerCase(),
      organizationId,
      organizationName,
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Failed to send invite: ${res.status}`);
  }

  return res.json();
}

export async function validateInvite(code) {
  const res = await fetch(
    `${API_BASE}/api/validate-invite?code=${encodeURIComponent(code)}`
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Invalid or expired invite");
  }

  return res.json();
}

export async function redeemInvite(code, userId) {
  const res = await fetch(`${API_BASE}/api/redeem-invite`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code, userId }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to redeem invite");
  }

  return res.json();
}
